var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSigoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 252.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.35,111.33c-.61-19.08-13.6-30.44-35.12-30.44-21.92,0-36.32,12-36.32,29.83,0,14.81,9.12,23.95,29.43,30,13.79,4.26,17.45,6.9,17.45,12.59,0,5.27-4.27,8.93-10.36,8.93-7.51,0-11.16-3.66-12.38-11.78H327.29c1,19.49,14.62,30.86,36.94,30.86,21.92,0,36.54-12.18,36.54-30.45,0-15.22-8.33-23.54-29.43-30-13-4.06-13.2-4.06-16-6.3a7.76,7.76,0,0,1-2.64-6.08c0-5.08,4.06-8.52,10.35-8.52,6.91,0,12,4,12,9.74v1.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 428.7,
    y: 85.04,
    width: 25.78,
    height: 93.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M578.42,171.21V84.13H553.05V95.7c-8.12-10.35-17.25-14.81-30.45-14.81-28.21,0-47.09,20.5-47.09,50.94,0,28.62,18.68,49.53,44.46,49.53,13.59,0,24.56-5.28,33.08-16v9.54c0,17.66-9.94,27.81-27.2,27.81-11.77,0-20.7-4.06-29-13l-16,16.24c12.79,12.58,27.81,18.67,46.08,18.67,16,0,29.83-5.08,39-14.21,8.93-8.73,12.58-19.89,12.58-39.17m-25.78-38.16c0,7.1-1.82,13-4.87,16.64a25.79,25.79,0,0,1-19.48,8.73c-14.82,0-25.37-11.57-25.37-27.81,0-15.62,10.35-26.79,25.17-26.79a26.16,26.16,0,0,1,17.66,7.31c4.66,4.87,6.89,11.77,6.89,21.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M700,132c0-29.63-21.31-51.14-51-51.14-30.44,0-51.35,20.5-51.35,50.33,0,29.23,21.32,50.14,50.95,50.14,28.82,0,51.35-21.72,51.35-49.33m-26-.4c0,15.63-10.35,26.79-25.17,26.79-15,0-25.17-11-25.17-27.2,0-16.44,10.15-27.2,25.37-27.2,15.43,0,25,10.56,25,27.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.59,70.44a18.78,18.78,0,1,0-18.93-18.78,18.85,18.85,0,0,0,18.93,18.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.18,0A126.19,126.19,0,1,0,252.37,126.19,126.33,126.33,0,0,0,126.18,0ZM232.4,126.19A106.22,106.22,0,1,1,126.18,20,106.34,106.34,0,0,1,232.4,126.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.38,187.31a3.78,3.78,0,1,0,3.77,3.78A3.78,3.78,0,0,0,167.38,187.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.38,185.47a3.78,3.78,0,1,0-3.78-3.78A3.78,3.78,0,0,0,167.38,185.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.55,187.31a3.78,3.78,0,1,0,3.77,3.77A3.79,3.79,0,0,0,157.55,187.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.63,187.31a3.78,3.78,0,1,0,3.78,3.77A3.78,3.78,0,0,0,147.63,187.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.08,187.31a3.78,3.78,0,1,0,3.77,3.77A3.79,3.79,0,0,0,138.08,187.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.32,187.31a3.78,3.78,0,1,0,3.78,3.77A3.78,3.78,0,0,0,128.32,187.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.93,187.31a3.78,3.78,0,1,0,3.78,3.77A3.78,3.78,0,0,0,118.93,187.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.55,185.47a3.78,3.78,0,1,0-3.77-3.78A3.77,3.77,0,0,0,157.55,185.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.63,177.92a3.78,3.78,0,1,0,3.78,3.77A3.78,3.78,0,0,0,147.63,177.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.08,177.92a3.78,3.78,0,1,0,3.77,3.77A3.79,3.79,0,0,0,138.08,177.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.33,177.92a3.78,3.78,0,1,0,3.77,3.77A3.78,3.78,0,0,0,128.33,177.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.93,177.92a3.78,3.78,0,1,0,3.78,3.77A3.78,3.78,0,0,0,118.93,177.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.54,177.92a3.78,3.78,0,1,0,3.77,3.77A3.79,3.79,0,0,0,109.54,177.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.38,159a3.78,3.78,0,1,0,3.77,3.77A3.77,3.77,0,0,0,167.38,159Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.38,149.61a3.78,3.78,0,1,0,3.77,3.78A3.78,3.78,0,0,0,167.38,149.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.38,147.77A3.78,3.78,0,1,0,163.6,144,3.78,3.78,0,0,0,167.38,147.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.55,159a3.78,3.78,0,1,0,3.77,3.77A3.77,3.77,0,0,0,157.55,159Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.55,149.61a3.78,3.78,0,1,0,3.77,3.78A3.78,3.78,0,0,0,157.55,149.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.55,140.22a3.78,3.78,0,1,0,3.77,3.78A3.78,3.78,0,0,0,157.55,140.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.55,130.83a3.78,3.78,0,1,0,3.77,3.77A3.77,3.77,0,0,0,157.55,130.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.63,159a3.77,3.77,0,1,0,3.77,3.77A3.77,3.77,0,0,0,147.63,159Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.63,149.61a3.78,3.78,0,1,0,3.77,3.78A3.78,3.78,0,0,0,147.63,149.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.63,140.22A3.78,3.78,0,1,0,151.4,144,3.78,3.78,0,0,0,147.63,140.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.63,130.83a3.78,3.78,0,1,0,3.77,3.78A3.78,3.78,0,0,0,147.63,130.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.63,121.44a3.78,3.78,0,1,0,3.77,3.77A3.77,3.77,0,0,0,147.63,121.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.38,168.4a3.78,3.78,0,1,0,3.77,3.77A3.77,3.77,0,0,0,167.38,168.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.55,168.4a3.78,3.78,0,1,0,3.77,3.77A3.77,3.77,0,0,0,157.55,168.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.63,168.4a3.78,3.78,0,1,0,3.77,3.77A3.77,3.77,0,0,0,147.63,168.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 138.08,
    cy: 172.17,
    r: 3.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.33,168.4a3.78,3.78,0,1,0,3.77,3.77A3.77,3.77,0,0,0,128.33,168.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.93,168.4a3.78,3.78,0,1,0,3.78,3.77A3.77,3.77,0,0,0,118.93,168.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.54,168.4a3.78,3.78,0,1,0,3.77,3.77A3.78,3.78,0,0,0,109.54,168.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.22,168.4a3.78,3.78,0,1,0,3.78,3.77A3.77,3.77,0,0,0,100.22,168.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.37 58.31 137.62 58.31 160.78 81.47 106.53 81.47 106.53 135.71 83.37 112.55 83.37 58.31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigoLogo);
export default __webpack_public_path__ + "static/media/sigo-logo.4c097c8ee924b85c58d56e9ca1257559.svg";
export { ForwardRef as ReactComponent };